// Unload delivery for analytics. sendBeacon first, keepalive fetch if the beacon is refused.
// Callers must not put tokens, emails, or names in the body.

export function deliverAnalyticsBeacon({ url, body, headers, beacon, fetchImpl } = {}) {
  if (!url || !body) return "";
  const sendBeacon = typeof beacon === "function"
    ? beacon
    : (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function"
      ? navigator.sendBeacon.bind(navigator)
      : null);
  const hasBearer = Boolean(headers && (headers.Authorization || headers.authorization));
  if (sendBeacon && !hasBearer) {
    try {
      const blob = typeof Blob !== "undefined" ? new Blob([body], { type: "application/json" }) : body;
      if (sendBeacon(url, blob) === true) return "beacon";
    } catch {
      // Beacon can be missing or rejected. Keepalive fetch is the same pipeline.
    }
  }
  const impl = fetchImpl || (typeof fetch !== "undefined" ? fetch : null);
  if (typeof impl !== "function") return "";
  try {
    const result = impl(url, {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: headers || { "Content-Type": "application/json" },
      body,
    });
    if (result && typeof result.catch === "function") result.catch(() => {});
    return "keepalive";
  } catch {
    return "";
  }
}
